import React from 'react'
import RasterLayer from './RasterLayer'

const Bathymetry = () => {
  return (
    <RasterLayer
      id='BathymetryFft'
      authId='Bathymetry'
      />
  )
}

export default Bathymetry



// WEBPACK FOOTER //
// ./src/layers/BathymetryFft.js